module.exports = __webpack_public_path__ + "static/media/cpg_ctv_morningnewschannel_video.560d492f.png";